export enum QueryKeys {
  GetAuthUser = 'getAuthUser',
  GetSettings = 'getSettings',
}
